/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ComplianceFindingFalsePositiveRequest,
  ComplianceFindingSummaryDto,
  ComplianceManualReviewListResponse,
} from '../models/index';
import {
    ComplianceFindingFalsePositiveRequestFromJSON,
    ComplianceFindingFalsePositiveRequestToJSON,
    ComplianceFindingSummaryDtoFromJSON,
    ComplianceFindingSummaryDtoToJSON,
    ComplianceManualReviewListResponseFromJSON,
    ComplianceManualReviewListResponseToJSON,
} from '../models/index';

export interface ClearComplianceManualReviewRequest {
    findingId: string;
    sessionId: string;
}

export interface ListComplianceManualReviewQueueRequest {
    sessionId: string;
    page?: number;
    size?: number;
}

export interface MarkComplianceFindingFalsePositiveRequest {
    findingId: string;
    sessionId: string;
    complianceFindingFalsePositiveRequest: ComplianceFindingFalsePositiveRequest;
}

/**
 * MDMComplianceFindingsApi - interface
 * 
 * @export
 * @interface MDMComplianceFindingsApiInterface
 */
export interface MDMComplianceFindingsApiInterface {
    /**
     * 
     * @summary Clear manual review flag (REQ-CF-05)
     * @param {string} findingId 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMComplianceFindingsApiInterface
     */
    clearComplianceManualReviewRaw(requestParameters: ClearComplianceManualReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComplianceFindingSummaryDto>>;

    /**
     * Clear manual review flag (REQ-CF-05)
     */
    clearComplianceManualReview(requestParameters: ClearComplianceManualReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComplianceFindingSummaryDto>;

    /**
     * 
     * @summary Manual review queue (REQ-CF-05)
     * @param {string} sessionId 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMComplianceFindingsApiInterface
     */
    listComplianceManualReviewQueueRaw(requestParameters: ListComplianceManualReviewQueueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComplianceManualReviewListResponse>>;

    /**
     * Manual review queue (REQ-CF-05)
     */
    listComplianceManualReviewQueue(requestParameters: ListComplianceManualReviewQueueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComplianceManualReviewListResponse>;

    /**
     * 
     * @summary Mark compliance finding FALSE_POSITIVE (REQ-CF-06)
     * @param {string} findingId 
     * @param {string} sessionId 
     * @param {ComplianceFindingFalsePositiveRequest} complianceFindingFalsePositiveRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MDMComplianceFindingsApiInterface
     */
    markComplianceFindingFalsePositiveRaw(requestParameters: MarkComplianceFindingFalsePositiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComplianceFindingSummaryDto>>;

    /**
     * Mark compliance finding FALSE_POSITIVE (REQ-CF-06)
     */
    markComplianceFindingFalsePositive(requestParameters: MarkComplianceFindingFalsePositiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComplianceFindingSummaryDto>;

}

/**
 * 
 */
export class MDMComplianceFindingsApi extends runtime.BaseAPI implements MDMComplianceFindingsApiInterface {

    /**
     * Clear manual review flag (REQ-CF-05)
     */
    async clearComplianceManualReviewRaw(requestParameters: ClearComplianceManualReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComplianceFindingSummaryDto>> {
        if (requestParameters['findingId'] == null) {
            throw new runtime.RequiredError(
                'findingId',
                'Required parameter "findingId" was null or undefined when calling clearComplianceManualReview().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling clearComplianceManualReview().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/compliance/findings/{findingId}/clear-manual-review`;
        urlPath = urlPath.replace(`{${"findingId"}}`, encodeURIComponent(String(requestParameters['findingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComplianceFindingSummaryDtoFromJSON(jsonValue));
    }

    /**
     * Clear manual review flag (REQ-CF-05)
     */
    async clearComplianceManualReview(requestParameters: ClearComplianceManualReviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComplianceFindingSummaryDto> {
        const response = await this.clearComplianceManualReviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Manual review queue (REQ-CF-05)
     */
    async listComplianceManualReviewQueueRaw(requestParameters: ListComplianceManualReviewQueueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComplianceManualReviewListResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling listComplianceManualReviewQueue().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/compliance/manual-review`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComplianceManualReviewListResponseFromJSON(jsonValue));
    }

    /**
     * Manual review queue (REQ-CF-05)
     */
    async listComplianceManualReviewQueue(requestParameters: ListComplianceManualReviewQueueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComplianceManualReviewListResponse> {
        const response = await this.listComplianceManualReviewQueueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark compliance finding FALSE_POSITIVE (REQ-CF-06)
     */
    async markComplianceFindingFalsePositiveRaw(requestParameters: MarkComplianceFindingFalsePositiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComplianceFindingSummaryDto>> {
        if (requestParameters['findingId'] == null) {
            throw new runtime.RequiredError(
                'findingId',
                'Required parameter "findingId" was null or undefined when calling markComplianceFindingFalsePositive().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling markComplianceFindingFalsePositive().'
            );
        }

        if (requestParameters['complianceFindingFalsePositiveRequest'] == null) {
            throw new runtime.RequiredError(
                'complianceFindingFalsePositiveRequest',
                'Required parameter "complianceFindingFalsePositiveRequest" was null or undefined when calling markComplianceFindingFalsePositive().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/compliance/findings/{findingId}/false-positive`;
        urlPath = urlPath.replace(`{${"findingId"}}`, encodeURIComponent(String(requestParameters['findingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ComplianceFindingFalsePositiveRequestToJSON(requestParameters['complianceFindingFalsePositiveRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComplianceFindingSummaryDtoFromJSON(jsonValue));
    }

    /**
     * Mark compliance finding FALSE_POSITIVE (REQ-CF-06)
     */
    async markComplianceFindingFalsePositive(requestParameters: MarkComplianceFindingFalsePositiveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComplianceFindingSummaryDto> {
        const response = await this.markComplianceFindingFalsePositiveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
